import { useContext } from "react";

import { WebTrackerContext } from "./WebTrackerProvider";

import type { WebTracker } from "../WebTracker";

const useWebTracker = (): WebTracker => {
  const webTracker = useContext(WebTrackerContext);

  if (!webTracker) {
    throw new Error(
      "Hook useWebTracker must be used within a WebTrackerProvider"
    );
  }

  return webTracker;
};

export { useWebTracker };
